
import { Component, State, Vue } from 'nuxt-property-decorator';
import Slider from '../Slider.vue';
import TooltipButton from '../TooltipButton.vue';
import CloseBtn from './CloseBtn.vue';
import SidePanelStore from './side-panel.store';
import { Font, SiteAppearance } from '@/types/pageContract';
import ClientSettings from '@/store/clientSettings.store';
import { Site } from '@/types/initialData';
import KeyHandleEventBus from '@/store/keyHandle.eventbus';

@Component({
  components: { CloseBtn, TooltipButton, Slider }
})
export default class ReadabilitySettingsPanel extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.appearance)
  appearance: SiteAppearance;

  currentTextSizeScale: number = 0;
  currentLineHeightScale: number = 0;
  currentLetterSpacing: number = 0;
  currentFontFamily: Font | null = null;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  get fonts(): Array<Font> {
    const defaultFont: Font = {
      name: `${this.appearance.fonts.content.name.replace(
        ', sans-serif',
        ''
      )} (${this.$tc('labels.usermenu.display.text-settings.standard')})`,
      url: this.appearance.fonts.content.url,
      defaultSize: this.appearance.fonts.content.defaultSize
    };
    return [defaultFont, ...ClientSettings.externalFonts];
  }

  get defaultSettingsChanged(): boolean {
    return ClientSettings.defaultSettingsChanged;
  }

  created() {
    this.updateValues();
  }

  mounted() {
    KeyHandleEventBus.$on('escape', this.closeSidePanel);
  }

  destroyed() {
    KeyHandleEventBus.$off('escape', this.closeSidePanel);
  }

  changeTextSizeScale(scale: number): void {
    if (ClientSettings.currentTextSizeScale === scale) {
      return;
    }

    ClientSettings.changeTextSizeScale(scale, this.site);
  }

  changeLineHeightScale(scale: number): void {
    if (ClientSettings.currentLineHeightScale === scale) {
      return;
    }

    ClientSettings.changeLineHeight(scale, this.site);
  }

  changeLetterSpacing(scale: number): void {
    if (ClientSettings.currentLetterSpacingScale === scale) {
      return;
    }

    ClientSettings.changeLetterSpacing(scale, this.site);
  }

  changeFontFamily(font: Font): void {
    ClientSettings.changeFontFamily(font.name, this.site);
  }

  closeSidePanel(): void {
    SidePanelStore.rightPanelIsOpen = false;
  }

  resetToDefaultSettings(): void {
    ClientSettings.resetReadabilitySettingsToDefault(this.site); // We need to reset the store values, before updating the local values
    this.updateValues();
    if (!this.defaultSettingsChanged) {
      document.documentElement.style.setProperty('--text-scale', '1');
    }
  }

  listItemFontFamily(fontName: string) {
    switch (fontName) {
      case 'Open Dyslexic':
        return `${fontName.replace(' ', '')}, serif`;
      case 'Libre Baskerville':
        return `${fontName}, serif`;
      case 'Montserrat':
        return `${fontName}, sans-serif`;
      case 'Newsreader':
        return `${fontName}, serif`;
      case 'Open Sans':
        return `${fontName}, sans-serif`;
    }
    return '';
  }

  private updateValues(): void {
    this.currentTextSizeScale = ClientSettings.currentTextSizeScale;
    this.currentLineHeightScale = ClientSettings.currentLineHeightScale;
    this.currentLetterSpacing = ClientSettings.currentLetterSpacingScale;
    this.currentFontFamily = ClientSettings.currentFont
      ? ClientSettings.currentFont
      : this.fonts[0];
  }
}
